import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'

@Component
export default class ConfigurationLocalAssaysSectionsModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly section!: Partial<ConfigurationSectionResponse>

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    get updateMode(): boolean {
        return !!this.section?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    get goToStateMachineButtonDisabled(): boolean {
        return !this.section?.id
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }

    goToStateMachine() {
        const goToRoute = { name: 'SubportionStateMachines', params: { sectionId: String(this.section.id) } }
        this.$router.push(goToRoute)
    }
}
